/**
 * Returns a human-readable label for an intervention category
 */
export const getInterventionCategoryLabel = (category: string): string => {
    switch (category) {
      case 'fire': return 'Požar';
      case 'technical': return 'Tehnično reševanje';
      case 'natural': return 'Naravna nesreča';
      case 'other': return 'Drugo';
      default: return 'Neznano';
    }
  };
  
  /**
   * Returns a human-readable label for a news category
   */
  export const getNewsCategoryLabel = (category: string): string => {
    switch (category) {
      case 'event': return 'Dogodek';
      case 'training': return 'Usposabljanje';
      case 'announcement': return 'Obvestilo';
      case 'other': return 'Drugo';
      default: return 'Neznano';
    }
  };